import { format, getZonedDate } from '@eika-infrastruktur/date';

const datePattern = 'dd.MM.yyyy';

export const formatDate = (date: Date) => format(getZonedDate(date), datePattern);
